/* eslint-disable */
import moment from 'moment-timezone'
import Vue from 'vue'
import Vuex from 'vuex'
import layout from './modules/layout'
import market from './modules/market'
import news from './modules/news'
import request from './modules/request'
import ticker from './modules/ticker'
import user from './modules/user'
import ideas from './modules/ideas'
import targets from './modules/targets'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    layout,
    market,
    ticker,
    news,
    request,
    user,
    ideas,
    targets,
  },
  strict: process.env.NODE_ENV !== 'production',
})

setInterval(() => {
  store.commit('market/refreshTimer')
}, 1000)

window.moment = moment

export default store
